import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import betSlip from './modules/betSlip'
import prematch from './modules/prematch'
import live from './modules/live'
import favorites from './modules/favorites'
import results from './modules/results'
import createPersistedState from 'vuex-persistedstate'
import rules from './modules/rules'

import AccountService from '@/services/AccountService'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { account, betSlip, prematch, live, favorites, results, rules },
  strict: true,
  plugins: [
    createPersistedState()
  ],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    modals: {
      LOGIN: false,
      PASSWORD_RECOVERY: false,
      REGISTER: false
    }
  },
  actions: {
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    setUser ({commit}, user) {
      commit('setUser', user)
    },

    async SET_USER_SETTING ({ commit }, params) {
      try {
        await AccountService.setting(params)
        commit('SET_USER_SETTING', params)
      } catch (error) {
        console.log(error.response.data.error)
      }
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      state.isUserLoggedIn = !!(token)
    },
    setUser (state, user) {
      state.user = user
    },

    SHOW_MODAL (state, modal) {
      state.modals[modal] = true
    },
    CLOSE_MODAL (state, modal) {
      state.modals[modal] = false
    },

    SET_USER_SETTING (state, params) {
      state.user.settings[params.name] = params.value
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js